import _map from 'lodash/map';

import initialState from './initialState';
import actionTypes from './actionTypes';

const matchingRulesNamesReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_MATCHING_RULE_NAMES_SUCCESS: {
            return {
                ...state,
                matchingRuleNames: action.payload,
                matchingRuleNamesForSelectionBox: _map(action.payload, (item) => ({
                    ...item,
                    label: item.rule_name,
                    value: item.rule_name,
                })),
            };
        }
        case actionTypes.GET_RECON_EVENT_RULE_SUCCESS: {
            const { mappedProcessingOrders, unMappedMatchingRules, unMappedWorkflowRules, allWorkFlowRules } = action.payload;
            return {
                ...state,
                mappedProcessingOrders,
                unMappedMatchingRules,
                unMappedWorkflowRules,
                allWorkFlowRules
            };
        }
        default:
            return state;
    }
};

export default matchingRulesNamesReducer;
